import { useDeleteSubPurposeMutation, type SubPurpose } from 'prove-common'
import { SubPurposeForm } from '../../components/reference-data/ReferenceEntityForms'
import { ReferenceTable } from '../reference-table/ReferenceTable'

export const SubPurposesTable = ({
  subPurposes
}: {
  subPurposes: SubPurpose[]
}) => {
  const remove = useDeleteSubPurposeMutation()
  return (
    <ReferenceTable
      rows={subPurposes}
      title='Underhensikter'
      emptyTitle='Ingen underhensikter'
      columns={[
        { key: 'name', label: 'Navn', value: (row) => row.name },
        { key: 'id', label: 'ID', value: (row) => row.id, copy: true }
      ]}
      name={(row) => row.name}
      editForm={(row, close) => (
        <SubPurposeForm subPurpose={row} onClose={close} />
      )}
      onDelete={(id) => remove.mutateAsync(id)}
    />
  )
}
